import PaymentReport from "./PaymentReport"

const exportObj = {
    PaymentReport
}

export default exportObj